var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 3.33325V19.9999C24.9997 21.8333 23.4997 23.3333 21.6663 23.3333H3.33301V9.99992C3.33301 6.31659 6.31634 3.33325 9.99967 3.33325H24.9997Z",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 23.3333V28.3333C36.6663 31.0999 34.433 33.3333 31.6663 33.3333H29.9997C29.9997 31.4999 28.4997 29.9999 26.6663 29.9999C24.833 29.9999 23.333 31.4999 23.333 33.3333H16.6663C16.6663 31.4999 15.1663 29.9999 13.333 29.9999C11.4997 29.9999 9.99967 31.4999 9.99967 33.3333H8.33301C5.56634 33.3333 3.33301 31.0999 3.33301 28.3333V23.3333H21.6663C23.4997 23.3333 24.9997 21.8333 24.9997 19.9999V8.33325H28.0663C29.2663 8.33325 30.3663 8.98327 30.9663 10.0166L33.8164 14.9999H31.6663C30.7497 14.9999 29.9997 15.7499 29.9997 16.6666V21.6666C29.9997 22.5833 30.7497 23.3333 31.6663 23.3333H36.6663Z",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 36.6667C15.1743 36.6667 16.6667 35.1743 16.6667 33.3333C16.6667 31.4924 15.1743 30 13.3333 30C11.4924 30 10 31.4924 10 33.3333C10 35.1743 11.4924 36.6667 13.3333 36.6667Z",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 36.6667C28.5073 36.6667 29.9997 35.1743 29.9997 33.3333C29.9997 31.4924 28.5073 30 26.6663 30C24.8254 30 23.333 31.4924 23.333 33.3333C23.333 35.1743 24.8254 36.6667 26.6663 36.6667Z",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6667 20V23.3333H31.6667C30.75 23.3333 30 22.5833 30 21.6667V16.6667C30 15.75 30.75 15 31.6667 15H33.8167L36.6667 20Z",
    stroke: "#494C50",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.3d88aa2877adea9b2b3890f80465c062.svg";
export { ForwardRef as ReactComponent };